import React, { Suspense, useEffect } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";
import Service from "./../custom_modules/general/Service.jsx";
import {
    Servicecalls,
    convertUTCDateToLocalDate,
    setDateAsuserDefined
} from "./../custom_functions/Functions.jsx";
import { convertshorthandtooriginal, convertprotocolshorthandtooriginal } from "./../custom_functions/Constance.jsx";
import { CheckBox } from "./../custom_modules/methodsetup/components/CustomControls.jsx";
import { Tooltip } from "@progress/kendo-react-tooltip";
const PageLoader = React.lazy(() => import("./../custom_modules/general/PageLoader.jsx"));
// @ts-expect-error
const ELNurl = window.appUrl.ELN;

const DetailComponent = props => {

    const [childdata, setChilddata] = React.useState(props.dataItem.details || []);
    const [columns, setColumns] = React.useState(props.griddetails.childcolumns);
    const [servicecall, setServicecall] = React.useState({
        ServiceToUrl: "",
        ServiceHeaderobject: {},
        ServiceMethodType: "POST",
        ServcieonSuccess: undefined,
        ServcieonFailure: undefined,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
    });
    const [iscolumnfilteropen, setIscolumnfilteropen] = React.useState(false);
    const [iscolumnfilter, setIscolumnfilter] = React.useState(false);
    const [countdatabound, setCountdatabound] = React.useState({});

    const radioselect = {};
    let gridnamevalue = props.griddetails.childgridname;
    if (props.griddetails && props.griddetails.childtoolbar) {
        props.griddetails.childtoolbar.map((tool) => {
            if (tool.ctrltype === "radio") {
                if (radioselect && !radioselect[tool.name]) {
                    radioselect[tool.name] = tool.value;
                    if (tool.dofetchonchange && tool.fetchurl && tool.columnsonfetch) {
                        gridnamevalue = props.griddetails.childgridname + "_" + tool.name + "_" + tool.value;
                    }
                }
            }

            return tool;
        });
    }
    const [gridname, setGridname] = React.useState(gridnamevalue);
    const [toolbarradio, setToolbarradio] = React.useState(radioselect);

    React.useEffect(() => {

        if (props.griddetails && props.griddetails.childtoolbar) {
            props.griddetails.childtoolbar.map((tool) => {

                if (tool.isshowcount && tool.countfetchurl) {
                    Servicecalls(tool.countfetchurl,
                        tool.countpassobject,
                        (responce) => {
                            countdatabound[tool.name + "_" + tool.value] = responce.count;
                            setCountdatabound(countdatabound);
                        },
                        (error) => { });
                }

                if (tool.ctrltype === "columnfilter") {
                    setIscolumnfilter(true);
                }
                return tool;
            });
        }

        if (gridname !== undefined) {
            let passObjDet = {
                gridname: gridname,
                usercode: sessionStorage.User,
                sitecode: sessionStorage.Usersite,
            };

            Servicecalls("" + ELNurl + "/User/getShowHideolumn", passObjDet, onGetShowHideColsuccess, () => { });
        }

    }, []);

    const formatchildcolumns = (columns) => {
        let updatedcolumns = [];
        columns && columns.map(col => {
            if (col.visible) {
                if (col.celltype && col.celltype === "link") {
                    updatedcolumns.push(linkcell(col));
                }
                else if (col.celltype && col.celltype === "status") {
                    updatedcolumns.push(statuscell(col));
                }
                else {
                    updatedcolumns.push(<Column field={col.datatype} title={col.header} />);
                }
            }
            return col;
        });
        return updatedcolumns;
    }
   
 const statuscell = (col) => {
    return (<Column 
        field={col.datatype} 
        title={col.header}
        cell={(data) => {
            let statusname = "";

            Object.keys(col.statusvalidation).forEach(key => {
                if (statusname === "") {
                    let isvalid = true;
                    Object.keys(col.statusvalidation[key]).forEach(statuskey => {
                        let cellValue = data.dataItem[statuskey] || ""; 
                        let validationValue = col.statusvalidation[key][statuskey] || ""; 

                   
                        if (cellValue.toString().trim() === "" && validationValue.toString().trim() === "") {
                            return; 
                        }

                        if (cellValue.toString().trim() !== validationValue.toString().trim()) {
                            isvalid = false;
                        }
                    });

                    if (isvalid) {
                        statusname = key;
                    }
                }
            });
            if (statusname === "") {
                statusname = "Approved";
            }

            return (
                <td>
                    <span className={"grid-custom-status " + statusname}>
                        {statusname}
                    </span>
                </td>
            );
        }}
    />);
}    
    const getlinkstate = (passdata, currentpath, dataItem) => {
        let statedata = {};
        if (passdata) {
            statedata = passdata;
            Object.keys(statedata).forEach(key => {
                if (dataItem[statedata[key]]) {
                    statedata[key] = dataItem[statedata[key]];
                }
            });
            statedata.perviouspath = currentpath;
        }
        return statedata;
    }
    const linkcell = (col) => {
        return (<Column field={col.datatype} title={col.header}
            cell={(data) => {

                let isnolink = false;

                if (!isnolink) {
                    Object.keys(col.noshowlink).forEach(key => {
                        if (data.dataItem[key] && data.dataItem[key] === col.noshowlink[key]) {
                            isnolink = true;
                        }
                    });
                }

                return <td>

                    {isnolink ?
                        <span> {data.dataItem[col.datatype]}</span> :
                        <NavLink className="column-simple-view"
                            to={{
                                pathname: col.pathName,
                                state: getlinkstate(JSON.parse(JSON.stringify(col.linkpassdata)), col.currentpath, data.dataItem)
                            }}

                        >
                            {<span> {data.dataItem[col.datatype]}</span>}
                        </NavLink>}

                </td >
            }}
        />)
    }

    const ontoolradiochange = (e, dofetch, fetchurl, radioname, columnsonfetch) => {
        if (e.target.checked === true && dofetch) {
            let passobject = { [props.griddetails.parentprimarykey]: props.dataItem[props.griddetails.parentprimarykey] };

            setServicecall({
                ServiceToUrl: fetchurl,
                ServiceHeaderobject: passobject,
                ServiceMethodType: "POST",
                ServcieonSuccess: (response) => {
                    setChilddata(response)
                },
                ServcieonFailure: (response) => { },
                ServiceTenant: undefined,
                Servicecontenttype: undefined,
            });

            toolbarradio[radioname] = e.target.value;
            setToolbarradio(toolbarradio);

            let gridnamevalue = props.griddetails.childgridname + "_" + radioname + "_" + e.target.value;
            setGridname(gridnamevalue);
            if (columnsonfetch) {
                // setColumns(columnsonfetch);
                if (gridnamevalue !== undefined) {
                    let passObjDet = {
                        gridname: gridnamevalue,
                        usercode: sessionStorage.User,
                        sitecode: sessionStorage.Usersite,
                    };

                    Servicecalls("" + ELNurl + "/User/getShowHideolumn", passObjDet, (response) => { onGetShowHidewithColsuccess(response, columnsonfetch) }, () => { });
                }
            }
        }
    }

    const onGetShowHideColsuccess = (response) => {
        if (response?.gridcolumns && response?.usergroupedcolcode) {
            const showColms = JSON.parse(response.gridcolumns);

            const stateShowColms = columns.map(item => {
                let isVisible = false;
                let dataindex = showColms.findIndex(col => { return col.datatype === item.datatype });
                if (dataindex > -1) {
                    isVisible = true;
                }
                else if (item.defaultvisible) {
                    isVisible = true;
                }

                return {
                    ...item,
                    visible: isVisible,
                };
            });

            setColumns(stateShowColms);
        } else {
            const stateShowColms = columns.map(item => {
                return {
                    ...item,
                    visible: true,
                };
            });
            setColumns(stateShowColms);
        }
    }

    const onGetShowHidewithColsuccess = (response, column) => {
        if (response?.gridcolumns && response?.usergroupedcolcode) {
            const showColms = JSON.parse(response.gridcolumns);

            const stateShowColms = column.map(item => {
                let isVisible = false;
                let dataindex = showColms.findIndex(col => { return col.datatype === item.datatype });
                if (dataindex > -1) {
                    isVisible = true;
                }
                else if (item.defaultvisible) {
                    isVisible = true;
                }

                return {
                    ...item,
                    visible: isVisible,
                };
            });

            setColumns(stateShowColms);
        } else {
            const stateShowColms = column.map(item => {
                return {
                    ...item,
                    visible: true,
                };
            });
            setColumns(stateShowColms);
        }
    }

    const onColumnfiltersection = (e) => {
        const { value, checked } = e.target;

        const updatedColumns = columns.map(item => item?.header === value ? { ...item, visible: checked } : item);

        if (gridname) {
            const usercode = sessionStorage.User;
            const sitecode = sessionStorage.Usersite;

            const passObjDet = {
                gridname: gridname,
                gridcolumns: JSON.stringify(updatedColumns.filter(item => item.visible).map(item => ({ datatype: item.datatype }))),
                usercode,
                sitecode
            };

            Servicecalls(`${ELNurl}/User/setShowHideolumn`, passObjDet, onGetShowHideColsuccess, () => { });
        }
    }

    const itemRenderShowHideColumnviewall = (columns) => {
        let Design = [];
        columns.map((items) => {
            (items?.header !== undefined && items?.header !== null) &&
                Design.push(
                    <em onClick={(e) => e.stopPropagation()} key={items.header}>
                        <CheckBox
                            onChange={onColumnfiltersection}
                            checked={items?.defaultvisible ? items?.defaultvisible : items?.visible}
                            value={items.header}
                            disabled={items?.defaultvisible}
                        />
                        {" " + items.header}
                    </em>)

        })
        return Design
    };

    const Columnfiltertoggle = (e) => {
        setIscolumnfilteropen(!iscolumnfilteropen);
    }

    const formatchildtoolbar = (tools) => {
        let toollist = [];
        tools.map((tool) => {
            if (tool.ctrltype === "radio") {

                toollist.push(<label className={"radio "}>
                    <input
                        type="radio"
                        value={tool.value}
                        name={tool.name}
                        onChange={(e) => { ontoolradiochange(e, tool.dofetchonchange, tool.fetchurl, tool.name, tool.columnsonfetch) }}
                        checked={toolbarradio[tool.name] && toolbarradio[tool.name] === tool.value ? true : false}
                    />
                    <span className="">
                        {tool.text}
                    </span>
                </label>);

            }
            else if (tool.ctrltype === "columnfilter") {
                toollist.push(<><Button className="btn_white_bg ml-3" title={this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")} onClick={Columnfiltertoggle}>
                    <img src="./images/eyeicon.png"/>
                </Button>{iscolumnfilteropen && (
                    <div id="viewallfilter" className="modal result-modal" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel" >
                        <div className="modal-dialog fixed-dailogbox modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")}</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={Columnfiltertoggle}
                                    >
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="viewall-list">{itemRenderShowHideColumnviewall(columns)}</div>
                                </div>
                                <div className="modal-footer">
                                    <button className="textBtn btn_white_bg" onClick={Columnfiltertoggle}>
                                      {this.props.t("Setup.Usermaster.IDS_LBL_CLOSE")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}</>);
            }
            return tool;
        });

        return toollist;
    }

    const formatdataforview = (column, data) => {
        let orginatecolumns = column.filter(col => { return col.orginatefrom !== undefined; });
        data = data && data.map(dat => {

            if (dat.bi) {
                dat = convertshorthandtooriginal(dat);
            }
            else if (dat.pn) {
                dat = convertprotocolshorthandtooriginal(dat);
            }

            orginatecolumns.map(orgcol => {
                if (dat[orgcol.orginatefrom]) {
                    if (orgcol.valuetype && orgcol.valuetype === "date") {
                        dat[orgcol.datatype] = setDateAsuserDefined(convertUTCDateToLocalDate(
                            new Date(dat[orgcol.orginatefrom])));
                    }
                    else {
                        dat[orgcol.datatype] = dat[orgcol.orginatefrom];
                    }
                }
                return orgcol;
            });
            return dat;
        });
        return data;
    }

    if (childdata) {
        return <div>
            {/* <div>
                <ul className="list-inline">
                    <li className="list-inline-item">
                        <div className="align-items-center mb-2 customUploadFile">
                            <span className="btn btn-file file-upload-btn">
                                <i className="fas fa-file-upload mr-2" />
                                {"Select file"}
                                <input
                                    // ref={this.aRef}
                                    className="btn-file"
                                    type="file"
                                    name="file"
                                    // onChange={this.onChangefile}
                                    accept={[".xls", ".xlsx"]}
                                />
                            </span>
                            <label className="uploaded-file ml-1">
                           
                            </label>
                        </div>
                    </li>
                </ul>
            </div> */}
            <Grid data={formatdataforview(columns, childdata)}>
                <GridToolbar>
                    {props.griddetails.childtoolbar && formatchildtoolbar(props.griddetails.childtoolbar)}
                </GridToolbar>
                {formatchildcolumns(columns)}
            </Grid>
            <Service
                Tourl={servicecall.ServiceToUrl}
                MethodType={servicecall.ServiceMethodType}
                onSuccess={servicecall.ServcieonSuccess}
                onFailure={servicecall.ServcieonFailure}
                Headerobject={servicecall.ServiceHeaderobject}
                onReseturl={() => {
                    setServicecall({ ...servicecall, ServiceToUrl: "" });
                }}
                ServiceTenant={servicecall.ServiceTenant}
                contenttype={servicecall.Servicecontenttype}
            ></Service>
        </div>;
    }
    return <div style={{
        height: '50px',
        width: '100%'
    }}>
        <Suspense fallback={<div></div>}>
            <PageLoader innerLoader={true} />
        </Suspense>
    </div>;
};

const KendoNestedGrid = (props) => {

    const [parentdata, setParentdata] = React.useState([]);
    const [columns, setColumns] = React.useState(props.griddetails.parentcolumns);
    const [iscolumnfilter, setIscolumnfilter] = React.useState(false);


    useEffect(() => {
        setColumns(props.griddetails.parentcolumns)
    }, [props.griddetails.parentcolumns]);

    const [servicecall, setServicecall] = React.useState({
        ServiceToUrl: "",
        ServiceHeaderobject: {},
        ServiceMethodType: "POST",
        ServcieonSuccess: undefined,
        ServcieonFailure: undefined,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
    });

    const radioselect = {};
    const countdata = {};
    let gridnamevalue = props.griddetails.praentgridname;
    if (props.griddetails && props.griddetails.parenttoolbar) {
        props.griddetails.parenttoolbar.map((tool) => {
            if (tool.ctrltype === "radio") {
                if (radioselect && !radioselect[tool.name]) {
                    radioselect[tool.name] = tool.value;
                }

                if (tool.dofetchonchange && tool.fetchurl && tool.columnsonfetch) {
                    gridnamevalue = props.griddetails.praentgridname + "_" + tool.name + "_" + tool.value;
                }
            }
            if (tool.isshowcount && tool.countfetchurl) {
                countdata[tool.name + "_" + tool.value] = 0;
            }
            return tool;
        });
    }
    const [gridname, setGridname] = React.useState(gridnamevalue);
    const [toolbarradio, setToolbarradio] = React.useState(radioselect);
    const [countdatabound, setCountdatabound] = React.useState(countdata);
    const [iscolumnfilteropen, setIscolumnfilteropen] = React.useState(false);


    const expandChange = event => {
        event.dataItem.expanded = event.value;

        let parentid = event.dataItem[props.griddetails.parentprimarykey];

        setParentdata([...parentdata]);

        if (!event.value || event.dataItem.details) {
            return;
        }

        if (props.griddetails.childfetchurl !== undefined) {
            let passobject = { [props.griddetails.parentprimarykey]: parentid };
            Servicecalls(props.griddetails.childfetchurl,
                passobject,
                (responce) => {
                    let data = parentdata.slice();
                    let index = data.findIndex(d => d[props.griddetails.parentprimarykey] === parentid);
                    data[index].details = responce;
                    setParentdata(data);
                },
                (error) => { }
            );
        }
    };

    const formatparentcolumns = (columns) => {
        let updatedcolumns = [];
        columns && columns.map(col => {
            if (col.visible) {
                updatedcolumns.push(<Column field={col.datatype} width={150} title={col.header} resizable={true} />);
            }
            return col;
        });
        return updatedcolumns;
    }

    useEffect(() => {

        if (props.griddetails.GridParentData !== undefined) {
            setParentdata(props.griddetails.GridParentData);
        }


    }, [props.griddetails.GridParentData])



    React.useLayoutEffect(() => {
        // fetch(baseUrl + `Categories`, init).then(response => response.json()).then(json => setCategories(json.value));

        if (props.griddetails.parentfetchurl !== undefined) {
            setServicecall({
                ServiceToUrl: props.griddetails.parentfetchurl,
                ServiceHeaderobject: props.griddetails.parentpassobject,
                ServiceMethodType: "POST",
                ServcieonSuccess: (response) => {
                    setParentdata(response)
                },
                ServcieonFailure: (response) => { },
                ServiceTenant: undefined,
                Servicecontenttype: undefined,
            });
        }
        // else if (props.griddetails.GridParentData !== undefined) {
        //     setParentdata(props.griddetails.GridParentData);
        // }

        if (props.griddetails && props.griddetails.parenttoolbar) {
            props.griddetails.parenttoolbar.map((tool) => {

                if (tool.isshowcount && tool.countfetchurl) {
                    Servicecalls(tool.countfetchurl,
                        tool.countpassobject,
                        (responce) => {
                            countdatabound[tool.name + "_" + tool.value] = responce.count;
                            setCountdatabound(countdatabound);
                        },
                        (error) => { });
                }

                if (tool.ctrltype === "columnfilter") {
                    setIscolumnfilter(true);
                }
                return tool;
            });
        }

        if (gridname !== undefined) {
            let passObjDet = {
                gridname: gridname,
                usercode: sessionStorage.User,
                sitecode: sessionStorage.Usersite,
            };

            Servicecalls("" + ELNurl + "/User/getShowHideolumn", passObjDet, onGetShowHideColsuccess, () => { });
        }

    }, []);

    const childcomponent = (colprops) => (<DetailComponent {...colprops}
        griddetails={props.griddetails}
        t={props.t}
    />)

    const formatdataforview = (column, data) => {
        let orginatecolumns = column.filter(col => { return col.orginatefrom !== undefined; });
        data = data && data.map(dat => {
            orginatecolumns.map(orgcol => {
                if (dat[orgcol.orginatefrom]) {
                    if (orgcol.valuetype && orgcol.valuetype === "date") {
                        dat[orgcol.datatype] = setDateAsuserDefined(convertUTCDateToLocalDate(
                            new Date(dat[orgcol.orginatefrom])));
                    }
                    else {
                        dat[orgcol.datatype] = dat[orgcol.orginatefrom];
                    }
                }
                return orgcol;
            });
            return dat;
        });
        return data;
    }

    const ontoolradiochange = (e, dofetch, fetchurl, radioname, columnsonfetch) => {
        if (e.target.checked === true && dofetch) {

            setServicecall({
                ServiceToUrl: fetchurl,
                ServiceHeaderobject: props.griddetails.parentpassobject,
                ServiceMethodType: "POST",
                ServcieonSuccess: (response) => {
                    setParentdata(response)
                },
                ServcieonFailure: (response) => { },
                ServiceTenant: undefined,
                Servicecontenttype: undefined,
            });

            toolbarradio[radioname] = e.target.value;
            setToolbarradio(toolbarradio);
            let gridnamevalue = props.griddetails.praentgridname + "_" + radioname + "_" + e.target.value;
            setGridname(gridnamevalue);
            if (columnsonfetch) {
                // setColumns(columnsonfetch);
                if (gridnamevalue !== undefined) {
                    let passObjDet = {
                        gridname: gridnamevalue,
                        usercode: sessionStorage.User,
                        sitecode: sessionStorage.Usersite,
                    };

                    Servicecalls("" + ELNurl + "/User/getShowHideolumn", passObjDet, (response) => { onGetShowHidewithColsuccess(response, columnsonfetch) }, () => { });
                }
            }
        }
    }

    const ontoolradiowithcountclick = (value, dofetch, fetchurl, radioname, columnsonfetch) => {
        if (dofetch) {

            setServicecall({
                ServiceToUrl: fetchurl,
                ServiceHeaderobject: props.griddetails.parentpassobject,
                ServiceMethodType: "POST",
                ServcieonSuccess: (response) => {
                    setParentdata(response)
                },
                ServcieonFailure: (response) => { },
                ServiceTenant: undefined,
                Servicecontenttype: undefined,
            });

            toolbarradio[radioname] = value;
            setToolbarradio(toolbarradio);
            let gridnamevalue = props.griddetails.praentgridname + "_" + radioname + "_" + value;
            setGridname(gridnamevalue);
            if (columnsonfetch) {
                // setColumns(columnsonfetch);
                if (gridnamevalue !== undefined) {
                    let passObjDet = {
                        gridname: gridnamevalue,
                        usercode: sessionStorage.User,
                        sitecode: sessionStorage.Usersite,
                    };

                    Servicecalls("" + ELNurl + "/User/getShowHideolumn", passObjDet, (response) => { onGetShowHidewithColsuccess(response, columnsonfetch) }, () => { });
                }
            }
        }
    }

    const Columnfiltertoggle = (e) => {
        setIscolumnfilteropen(!iscolumnfilteropen);
    }


    const formatparenttoolbar = (tools) => {
        let toollist = [];
        tools.map((tool) => {
            if (tool.isshowcount && tool.ctrltype === "radio") {
                toollist.push(
                    <div className='statistics-card-wrap' style={{ width: "15.5%" }}>
                        <div className={`statistics-card ${toolbarradio[tool.name] && toolbarradio[tool.name] === tool.value ? "cls_dashselect" : ""}`} style={{ width: "100%" }}>
                            <div className="card-body" onClick={(e) => { ontoolradiowithcountclick(tool.value, tool.dofetchonchange, tool.fetchurl, tool.name, tool.columnsonfetch) }}>
                                <div className="row no-gutters align-items-center">
                                    <div className="col-auto mr-2">
                                        <img
                                            src={tool.image}
                                            alt="completed"
                                            width="41"
                                            height="55"
                                        />
                                    </div>
                                    <div className="col" style={{ textAlign: "left" }}>
                                        <div className="status-count">
                                            {countdatabound[tool.name + "_" + tool.value]}
                                        </div>
                                        <div className="status-txt">
                                            <span title={tool.text}>
                                                {tool.text}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    // <label className={"radio "}>
                    //     <input
                    //         type="radio"
                    //         value={tool.value}
                    //         name={tool.name}
                    //         onChange={(e) => { ontoolradiochange(e, tool.dofetchonchange, tool.fetchurl, tool.name, tool.columnsonfetch) }}
                    //         checked={toolbarradio[tool.name] && toolbarradio[tool.name] === tool.value ? true : false}
                    //     />
                    //     <span className="">
                    //         {tool.text} {tool.isshowcount && tool.countfetchurl && (<span>({countdatabound[tool.name + "_" + tool.value]})</span>)}
                    //     </span>
                    // </label>
                );
            }
            else if (tool.ctrltype === "radio") {

                toollist.push(<label className={"radio "}>
                    <input
                        type="radio"
                        value={tool.value}
                        name={tool.name}
                        onChange={(e) => { ontoolradiochange(e, tool.dofetchonchange, tool.fetchurl, tool.name, tool.columnsonfetch) }}
                        checked={toolbarradio[tool.name] && toolbarradio[tool.name] === tool.value ? true : false}
                    />
                    <span className="">
                        {tool.text} {tool.isshowcount && tool.countfetchurl && (<span>({countdatabound[tool.name + "_" + tool.value]})</span>)}
                    </span>
                </label>);

            }
            else if (tool.ctrltype === "columnfilter") {
                toollist.push(<><Button className="btn_white_bg ml-3" title={this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")} onClick={Columnfiltertoggle}>
                    <img src="./images/eyeicon.png"/>
                </Button>{iscolumnfilteropen && (
                    <div id="viewallfilter" className="modal result-modal" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel" >
                        <div className="modal-dialog fixed-dailogbox modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{this.props.t("Setup.Usermaster.IDS_LBL_SHOWHIDECOLLUMN")}</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={Columnfiltertoggle}
                                    >
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="viewall-list">{itemRenderShowHideColumnviewall(columns)}</div>
                                </div>
                                <div className="modal-footer">
                                    <button className="textBtn btn_white_bg" onClick={Columnfiltertoggle}>
                                       {this.props.t("Setup.Usermaster.IDS_LBL_CLOSE")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}</>);
            }
            return tool;
        });

        return toollist;
    }

    const onGetShowHideColsuccess = (response) => {
        if (response?.gridcolumns && response?.usergroupedcolcode) {
            const showColms = JSON.parse(response.gridcolumns);

            const stateShowColms = columns.map(item => {
                let isVisible = false;
                let dataindex = showColms.findIndex(col => { return col.datatype === item.datatype });
                if (dataindex > -1) {
                    isVisible = true;
                }
                else if (item.defaultvisible) {
                    isVisible = true;
                }

                return {
                    ...item,
                    visible: isVisible,
                };
            });

            setColumns(stateShowColms);
        } else {
            const stateShowColms = columns.map(item => {
                return {
                    ...item,
                    visible: true,
                };
            });
            setColumns(stateShowColms);
        }
    }

    const onGetShowHidewithColsuccess = (response, column) => {
        if (response?.gridcolumns && response?.usergroupedcolcode) {
            const showColms = JSON.parse(response.gridcolumns);

            const stateShowColms = column.map(item => {
                let isVisible = false;
                let dataindex = showColms.findIndex(col => { return col.datatype === item.datatype });
                if (dataindex > -1) {
                    isVisible = true;
                }
                else if (item.defaultvisible) {
                    isVisible = true;
                }

                return {
                    ...item,
                    visible: isVisible,
                };
            });

            setColumns(stateShowColms);
        } else {
            const stateShowColms = columns.map(item => {
                return {
                    ...item,
                    visible: true,
                };
            });
            setColumns(stateShowColms);
        }
    }

    const onColumnfiltersection = (e) => {
        const { value, checked } = e.target;

        const updatedColumns = columns.map(item => item?.header === value ? { ...item, visible: checked } : item);

        if (gridname) {
            const usercode = sessionStorage.User;
            const sitecode = sessionStorage.Usersite;

            const passObjDet = {
                gridname: gridname,
                gridcolumns: JSON.stringify(updatedColumns.filter(item => item.visible).map(item => ({ datatype: item.datatype }))),
                usercode,
                sitecode
            };

            Servicecalls(`${ELNurl}/User/setShowHideolumn`, passObjDet, onGetShowHideColsuccess, () => { });
        }
    }

    const itemRenderShowHideColumnviewall = (columns) => {
        let Design = [];
        columns.map((items) => {
            (items?.header !== undefined && items?.header !== null) &&
                Design.push(
                    <em onClick={(e) => e.stopPropagation()} key={items.header}>
                        <CheckBox
                            onChange={onColumnfiltersection}
                            checked={items?.defaultvisible ? items?.defaultvisible : items?.visible}
                            value={items.header}
                            disabled={items?.defaultvisible}
                        />
                        {" " + items.header}
                    </em>)

        })
        return Design
    };

    return <div className='at-list-table importdata'>
        {/* <Tooltip openDelay={100} position="bottom">
            <div className='statistics-card-wrap'>
            {props.griddetails?.parenttoolbar && formatparenttoolbar(props.griddetails.parenttoolbar)}
            </div>
        </Tooltip> */}
        <Grid style={{
            height: '59vh'
        }} data={parentdata.length > 0 && formatdataforview(columns, parentdata)}
        resizable={true}
            //  detail={childcomponent} 
            detail={props?.showChild === undefined ? childcomponent : undefined}
            expandField="expanded" onExpandChange={expandChange}>
            <GridToolbar>
                {props.griddetails?.parenttoolbar && formatparenttoolbar(props.griddetails.parenttoolbar)}
            </GridToolbar>
            {formatparentcolumns(columns)}
        </Grid>

        <Service
            Tourl={servicecall.ServiceToUrl}
            MethodType={servicecall.ServiceMethodType}
            onSuccess={servicecall.ServcieonSuccess}
            onFailure={servicecall.ServcieonFailure}
            Headerobject={servicecall.ServiceHeaderobject}
            onReseturl={() => {
                setServicecall({ ...servicecall, ServiceToUrl: "" });
            }}
            ServiceTenant={servicecall.ServiceTenant}
            contenttype={servicecall.Servicecontenttype}
        ></Service>
    </div>;
};
export default withAlert()(withTranslation(KendoNestedGrid));